export const VALID_IMAGE_FORMAT = ['jpg', 'jpeg', 'png'];

export const INVALID_FORMAT_WARNING = {
  title: 'Invalid',
  description: 'Select only image format files for images. E.g. JPG JPEG PNG.',
};
